// Generated by GitHub Copilot
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

/**
 * Root component — provides the router outlet only.
 * Page-level concerns (title, meta) are handled per-route.
 */
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
  styles: []
})
export class AppComponent {
  constructor(private title: Title) {
    this.title.setTitle('Iberdrola Promo — Panel de gestión');
  }
}
